var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2089 22.3867L9.87891 22.5767L9.87924 22.196C9.87924 22.196 9.87457 22.3907 9.96247 22.4394C10.0486 22.487 10.2089 22.3867 10.2089 22.3867Z",
    fill: "#8E3315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74023 21.9983C3.59987 25.5077 6.78043 28.1356 10.5822 29.3047C14.384 30.4739 18.4956 30.0881 22.0126 28.2323C25.5294 26.3764 28.1637 23.2025 29.3355 19.4086C30.5074 15.6148 30.113 11.5119 28.2533 8.00256C29.9302 13.2765 24.0921 15.1293 24.0921 15.1293L17.0261 18.8146L9.68251 22.6367C9.68251 22.6367 4.67751 25.852 1.74023 21.9983Z",
    fill: "#473ADE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 22.0213C3.57447 25.5307 6.75502 28.1591 10.5568 29.3284C14.3587 30.4975 18.4702 30.1117 21.9871 28.2558C25.5041 26.4 28.1382 23.226 29.31 19.4321C30.482 15.6382 30.0956 11.5352 28.2359 8.02576C29.9129 13.2999 24.0667 15.1526 24.0667 15.1526L17.0007 18.838L9.65712 22.6602C9.65712 22.6602 4.65211 25.875 1.71484 22.0213Z",
    fill: "url(#paint0_linear_4047_13330)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9053 14.7632L24.4508 15.0282L23.875 15.2592C23.875 15.2592 24.122 15.1426 24.1515 15.0282C24.1804 14.9162 23.9053 14.7632 23.9053 14.7632Z",
    fill: "#251E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.345 21.8402C30.1609 18.3082 30.4964 14.2008 29.2775 10.4217C28.0587 6.64267 25.3854 3.50147 21.8458 1.68915C18.3062 -0.123171 14.1901 -0.458156 10.403 0.757888C6.61603 1.97393 3.46832 4.6414 1.65234 8.17351C5.02211 3.77946 9.89416 7.49833 9.89416 7.49833L16.9702 11.1645L24.3177 14.9791C24.3177 14.9791 29.826 17.2296 28.345 21.8402Z",
    fill: "#D71D6A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3084 21.8255C30.119 18.304 30.4535 14.2089 29.2382 10.4411C28.0231 6.6733 25.3577 3.54145 21.8286 1.73453C18.2995 -0.0723964 14.1956 -0.406384 10.42 0.806037C6.64422 2.01846 3.50588 4.67798 1.69531 8.1995C5.05504 3.81861 9.91263 7.52641 9.91263 7.52641L16.9675 11.1816L24.2931 14.985C24.2931 14.985 29.7851 17.2286 28.3084 21.8255Z",
    fill: "url(#paint1_linear_4047_13330)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87914 7.85417L9.87305 7.45557L10.2215 7.64945C10.2215 7.64945 10.0455 7.54624 9.95621 7.60184C9.86878 7.65636 9.87914 7.85417 9.87914 7.85417Z",
    fill: "#741039"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 0.03479C11.0214 0.0347909 7.20616 1.61191 4.39323 4.4192C1.58029 7.22647 7.57605e-07 11.034 0 15.0041C0 18.9742 1.58029 22.7817 4.39323 25.589C7.20616 28.3962 11.0214 29.9734 14.9995 29.9734C9.8939 29.118 9.8939 22.517 9.8939 22.517V15.0041V7.35825C9.8939 7.35825 9.8939 0.946717 14.9995 0.03479Z",
    fill: "#FF5B25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 0C11.0214 0 7.20616 1.57712 4.39323 4.3844C1.5803 7.19168 7.57605e-07 10.9992 0 14.9693C0 18.9394 1.58029 22.7469 4.39323 25.5542C7.20616 28.3615 11.0214 29.9385 14.9995 29.9385C9.89384 28.3108 9.89384 22.5254 9.89384 22.5254V14.9878V7.49824C9.89384 7.49824 9.70815 0.970054 14.9995 0Z",
    fill: "url(#paint2_linear_4047_13330)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 0C11.0214 0 7.20616 1.57712 4.39323 4.3844C1.5803 7.19168 7.57605e-07 10.9992 0 14.9693C0 18.9394 1.58029 22.7469 4.39323 25.5542C7.20616 28.3615 11.0214 29.9385 14.9995 29.9385C9.89384 28.3108 9.89384 22.5254 9.89384 22.5254V14.9878V7.49824C9.89384 7.49824 9.70815 0.970054 14.9995 0Z",
    fill: "url(#paint3_linear_4047_13330)",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9593 29.9648C9.89305 27.6621 9.89901 22.5212 9.89901 22.5212C9.89901 22.5212 3.61978 26.0559 1.50586 21.535C1.50586 21.535 5.04952 29.9949 14.9593 29.9648Z",
    fill: "#473ADE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4047_13330",
    x1: 28.2371,
    y1: 13.2963,
    x2: 6.45695,
    y2: 34.8451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655513,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4047_13330",
    x1: 6.00967,
    y1: 5.18695,
    x2: 36.0822,
    y2: 10.7156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4047_13330",
    x1: 8.03262,
    y1: 28.0842,
    x2: -0.856922,
    y2: 0.646583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675464,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4047_13330",
    x1: 8.03262,
    y1: 28.0842,
    x2: -0.856922,
    y2: 0.646583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675464,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlix);
export default __webpack_public_path__ + "static/media/flix.018fc143da39914eea5e16dc20742c6c.svg";
export { ForwardRef as ReactComponent };